import { makeStyles, css } from '@conexasaude/conexa-hero'

const useStyles = makeStyles({
  modalContent: ({ spacing }) => css`
    margin: ${spacing.xxs} 0 ${spacing.sm} 0;
  `,

  subtitle: css`
    display: flex;
    flex-direction: column;
  `,

  dependentSection: css`
    display: flex;
    flex-direction: column;
  `,

  dependentList: css`
    display: flex;
    flex-direction: column;
  `,

  dependentListItem: theme => css`
    display: flex;
    align-items: center;
    text-align: center;
    gap: ${theme.spacing.xxs};
    justify-content: space-between;
    margin-top: ${theme.spacing.xxs};
    padding: ${theme.spacing.xxs} 0;
    cursor: pointer;
  `,

  leftAligned: theme => css`
    display: flex;
    align-items: center;
    gap: ${theme.spacing.xs};
  `,

  tagWrapper: css`
    display: flex;
    align-items: center;
  `,

  tag: () => css`
    max-width: 80px;
  `,

  listTitle: theme => css`
    display: flex;
    align-items: center;
    margin-top: ${theme.spacing.xs};

    span {
      margin-left: 3px;
      font-weight: ${theme.fontWeights.bold};
    }
    svg {
      display: flex;
      align-items: center;
      margin-left: ${theme.spacing.xxs};
    }
    &:nth-of-type(2) {
      margin-top: ${theme.spacing.sm};
    }
  `,

  divisorLineWrapper: css`
    div {
      max-height: 0.5px;
    }
  `,
})

export { useStyles }
